import classNames from 'classnames';
import React, { useContext, useState } from 'react';
import { StorageProviderKey } from '../../models/storageProviderKeys';
import { GoogleApiContext, GoogleScope } from '../../services/gapi/gapiService';
import { Context } from '../../services/_globalContext/context';
import AuthorizeButton from '../common/authorizeButton/authorizeButton';
import ProviderList from './providerList';
import s from './settingsComponent.module.scss';

interface Props {
}

export default function SetupComponent({
}: Props) {

  const ctx = useContext(Context);
  const gapiCtx = useContext(GoogleApiContext);

  const [showAdvanced, setShowAdvanced] = useState(false);

  async function gapiEasySetup() {
    try {
      await gapiCtx.authorize({
        scope: GoogleScope.AppData,
        // A deliberate press of the sign-in button, so going to Google is
        // exactly what the user is asking for.
        allowRedirect: true,
        // On iOS that call navigates away and never comes back here, so the
        // line below is not reached. The intent is what makes Drive the
        // storage provider once the token lands.
        intent: { configureProvider: true },
      });
    }
    catch (err) {
      // Do not configure Drive as the storage provider when sign-in failed.
      // The first read would reset it and bounce straight back here.
      ctx.callSnackbar(err);
      return;
    }

    ctx.configureStorageProvider(StorageProviderKey.GoogleDrive);
  }

  return (
    <article className={classNames('mainViewport', ctx.playerSize, s.settings)}>
      <article>
        <section>
          <h5>Fadila music player setup</h5>
          <p>To use Fadila you must first sign in with Google and allow it to store your music library in your account.</p>
        </section>
        {(!gapiCtx.gapiAuthorized || !ctx.storageProvider.current) &&
          <>
            <div className={s.easySignin}>
              <AuthorizeButton
                google
                busy={gapiCtx.isAuthorizing}
                onClick={gapiEasySetup}
              />
            </div>
            <div className={s.advancedBtn}>
              <button className="button" onClick={() => setShowAdvanced(!showAdvanced)}>
                {showAdvanced ? 'Hide' : 'Show'} Advanced
              </button>
            </div>
          </>
        }
        {showAdvanced &&
          <div>
            <ProviderList setup />
            {gapiCtx.gapiAuthorized &&
              <button
                className="button"
                onClick={gapiCtx.resetAppDataFolder}
              >
                Reset GoogleDrive AppData
              </button>
            }
          </div>
        }
      </article>
      <br />
    </article>
  );
}
